export default (url, fields) => {
    const form = document.createElement('form');
    form.method = 'post';
    form.action = url;
    form.style.display = 'none';
    for (const [name, value] of Object.entries(fields)) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
    }
    document.body.appendChild(form);
    form.submit();
}